export class UserSettings {
  Num_Periods: number;
  Survival_Horizon: string;
  Max_Idle_Time?: number;
  File_Location?: string;
}
